module.exports = __webpack_public_path__ + "img/9.86f98d15.png";